import { render, staticRenderFns } from "./AdminBusinessView.vue?vue&type=template&id=0de1390a"
import script from "./AdminBusinessView.vue?vue&type=script&lang=js"
export * from "./AdminBusinessView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports